import { Slide } from "../../components/Carousel/carouselContents";
import gracePlan from "../../assets/images/gracePlan.png";
import graceList from "../../assets/images/graceList.png";
import graceHome from "../../assets/images/graceHome.png";
import graceMission from "../../assets/images/graceMission.png";
import graceContact from "../../assets/images/graceContact.png";
import graceAdmin from "../../assets/images/graceAdminSermon.png";

export const graceCarouselContents: Slide[] = [
  {
    cImg: `${graceHome}`,
    cAlt: "Screenshot of the Home page from moreofgrace.org",
  },
  {
    cImg: `${gracePlan}`,
    cAlt: "Screenshot of the Plan Your Visit page from moreofgrace.org",
  },
  {
    cImg: `${graceMission}`,
    cAlt: "Screenshot of the Who We Are page from moreofgrace.org",
  },
  {
    cImg: `${graceList}`,
    cAlt: "Screenshot of the Sermon List page from moreofgrace.org",
  },
  {
    cImg: `${graceContact}`,
    cAlt: "Screenshot of the Contact page from moreofgrace.org",
  },
  {
    cImg: `${graceAdmin}`,
    cAlt: "Screenshot of the Admin Sermon page from moreofgrace.org",
  },
];
